var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 6,
    viewBox: "0 0 24 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 3.5H1.5C0.671578 3.5 0 2.82842 0 2C0 1.17158 0.671578 0.5 1.5 0.5H22.5C23.3284 0.5 24 1.17158 24 2C24 2.82842 23.3284 3.5 22.5 3.5Z",
    fill: "#374957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineGray);
export default __webpack_public_path__ + "static/media/lineGray.1eb17dbfa3534c7b00694e3f86555e68.svg";
export { ForwardRef as ReactComponent };